'use strict';

var EndpointDesignGuidelineTemplateType = /*#__PURE__*/function (EndpointDesignGuidelineTemplateType) {
  EndpointDesignGuidelineTemplateType["COMPLETE"] = "COMPLETE";
  EndpointDesignGuidelineTemplateType["SIMPLE"] = "SIMPLE";
  return EndpointDesignGuidelineTemplateType;
}({});
exports.EndpointDesignGuidelineTemplateType = EndpointDesignGuidelineTemplateType;
